import React from 'react'
import Navbar from '../inc/Navbar'
import Aboutus from './Aboutus'
import ScrollToTop from "react-scroll-to-top";
import {Link} from "react-router-dom";


function Aboutuspage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
       
        <ScrollToTop smooth top="100" color="maroon"/>

<div className='ranaghatsareenew'>
<div className="album py-1">
<div className="container mt-4">
<nav aria-label="breadcrumb">
  <ol className="breadcrumb">
    <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
    <li className="breadcrumb-item active" aria-current="page">Contact us</li>
  </ol>
</nav>
</div>
</div>
</div>
<br/>

        <Aboutus/>
        <br/>
    </div>
  )
}

export default Aboutuspage